import React, { useEffect, useState } from 'react';
import { FlameIcon, ClockIcon } from 'lucide-react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 38,
    minutes: 35,
    seconds: 39
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  return <div className="bg-burgundy text-cream py-2 px-4 sticky top-0 z-50 w-full border-b border-peach/20" data-id="element-566">
      <div className="container mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-xs sm:text-sm font-medium tracking-wide uppercase" data-id="element-567">
        <div className="flex items-center gap-2" data-id="element-568">
          <FlameIcon className="w-4 h-4 text-peach" data-id="element-569" />
          <span data-id="element-570">Oferta de lanzamiento · 63% OFF</span>
        </div>
        <span className="hidden sm:inline text-peach/50" data-id="element-571">·</span>
        <div className="flex items-center gap-2" data-id="element-572">
          <ClockIcon className="w-4 h-4 text-peach" data-id="element-573" />
          <span className="tabular-nums" data-id="element-574">
            Termina en {formatTime(timeLeft.hours)}:
            {formatTime(timeLeft.minutes)}:{formatTime(timeLeft.seconds)}
          </span>
        </div>
      </div>
    </div>;
}